import { createEnum } from "@redotech/zod-util/zod-enum";
import { SortDirection, TableSort, createTableSortSchema } from "./table";

/** Columns in the conversations table that the user can sort the table by */
export const sortableConversationsTableColumns = [
  "customer",
  "summary",
  "assignee",
  "platform",
  "lastResponse",
  "lastMerchantResponse",
  "createdAt",
  "priority",
] as const;

export type SortableConversationTableColumn =
  (typeof sortableConversationsTableColumns)[number];
export const SortableConversationTableColumn =
  sortableConversationsTableColumns;

export const defaultConversationsTableSort: TableSort<SortableConversationTableColumn> =
  { key: "lastResponse", direction: SortDirection.DESC };

export const SortableConversationTableColumnSchema = createEnum(
  sortableConversationsTableColumns,
);

export const ConversationTableSortSchema = createTableSortSchema(
  SortableConversationTableColumnSchema,
);
